import axios from 'axios'
import authHeader from '@/services/auth-header'

export default class BirthdayReminderService {
  static async new(birthdayreminder) {
    return axios
      .post(`${process.env.VUE_APP_BACK_URL}/birthdayreminder/new`,
        birthdayreminder,
        { headers: authHeader() })
      .then(response => response.data)
  }

  static getAll() {
    return axios
      .get(`${process.env.VUE_APP_BACK_URL}/birthdayreminder/get-all`,
        { headers: authHeader() })
      .then(response => response.data)
  }

  static delete(birthdayreminder) {
    return axios.post(`${process.env.VUE_APP_BACK_URL}/todo`, { headers: authHeader(), birthdayreminder })
  }
}

// export default new AuthService()
